const groupContractCodes = [
  'BSG1',
  'BSG2',
  'BSG3',
  'BSG4',
  'OS_GROUP',
  'GROUP',
  'JOL',
  'TEAMGB',
  'TEAMBE',
  'TEAMNL',
  'TEAMDE',
  'PARALYMPIC',
  'PARALNL',
  'PARALBE',
  'MICE_GROUP',
  'COMPNL',
  'COMPBE',
  'GROUP_YTH'
];

export default groupContractCodes;
